import React from 'react';
// noinspection NpmUsedModulesInstalled
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';

import Translate from '~/components/Translate/Translate';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: '',
            errorStack: ''
        };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            errorMessage: error.message,
            errorStack: error.stack
        };
    }

    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const { errorStack, errorMessage = 'Error' } = this.state;
            if (APP_INFO.debug) {
                return (
                    <Container>
                        <Row>
                            <Col>
                                <div className="error-boundary">
                                    <h1>
                                        <Translate message="OOPS!" />
                                    </h1>
                                    <h2>{errorMessage}</h2>
                                    <pre>{errorStack}</pre>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                );
            } else {
                console.error(new Error(errorMessage, { details: errorStack }));
            }
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node
};
